

export const EcommerceOverview = {
    "kpi": [
        {
            "id": "edc36040-820e-474d-8750-3c6b5ff3784b",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as total_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"total_sales": 8796.6}
            ],
            "unit": "USD",
            "title": "Total Sales",
            "action": "update",
            "column": "total_sales",
            "format": "currency",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of total_price from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Sum all total_price values from Shopify orders within the specified date range to calculate total revenue.",
            "prevData": [
                {"total_sales": null}
            ]
        },
        {
            "id": "12f118b8-d361-43ee-bff7-bb1353fc4e38",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC) - CAST(total_discounts AS NUMERIC)), 2) as net_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"net_sales": 8796.6}
            ],
            "unit": "USD",
            "title": "Net Sales",
            "action": "update",
            "column": "net_sales",
            "format": "currency",
            "layout": {
                "x": 3,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of (total_price - total_discounts) from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Calculate net sales by subtracting total discounts from total price for all orders within the specified date range.",
            "prevData": [
                {"net_sales": null}
            ]
        },
        {
            "id": "51c82f04-b7f6-4f4e-a441-2d256d7c884b",
            "sql": "SELECT COUNT(*) as orders FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"orders": 32}
            ],
            "unit": "Orders",
            "title": "Orders",
            "action": "update",
            "column": "orders",
            "format": "number",
            "layout": {
                "x": 9,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Count of total orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Count the total number of orders placed within the specified date range.",
            "prevData": [
                {"orders": 0}
            ]
        },
        {
            "id": "0204ce0e-56f5-4d66-9162-720d054a69e2",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC)) / COUNT(*), 2) as aov FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"aov": 274.89}
            ],
            "unit": "USD",
            "title": "Average Order Value (AOV)",
            "action": "update",
            "column": "aov",
            "format": "currency",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Total Sales divided by total number of orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Calculate Average Order Value by dividing the sum of total_price by the count of orders within the specified date range.",
            "prevData": [
                {"aov": null}
            ]
        },
        {
            "id": "c00f3259-ae6e-420c-b362-bfd9ae9de4dc",
            "sql": "SELECT SUM(quantity) as total_products_sold FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"total_products_sold": 12}
            ],
            "unit": "Items",
            "title": "Total Products Sold",
            "action": "update",
            "column": "total_products_sold",
            "format": "number",
            "layout": {
                "x": 0,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of quantity from all line items within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Sum the quantity of all order line items within the specified date range to determine total units sold.",
            "prevData": [
                {"total_products_sold": null}
            ]
        },
        {
            "id": "ecd6a987-fcf1-4f63-b6a0-6b44716c7eb6",
            "sql": "SELECT ROUND(SUM(CAST(total_discounts AS NUMERIC)), 2) as discounts FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"discounts": 0}
            ],
            "unit": "USD",
            "title": "Discounts",
            "action": "update",
            "column": "discounts",
            "format": "currency",
            "layout": {
                "x": 3,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of total_discounts from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Sum all total_discounts values from Shopify orders within the specified date range to calculate total discount amount.",
            "prevData": [
                {"discounts": null}
            ]
        },
        {
            "id": "0395ae36-5521-4b53-b8dd-34f46211fbfa",
            "sql": "SELECT ROUND(COALESCE(SUM(CAST(raw->'refunds'->0->>'subtotal' AS NUMERIC)), 0), 2) as refunds FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'",
            "data": [
                {"refunds": 0}
            ],
            "unit": "USD",
            "title": "Refunds",
            "action": "update",
            "column": "refunds",
            "format": "currency",
            "layout": {
                "x": 6,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of refunded amounts from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Extract and sum refund subtotal values from the JSON raw data in refunds field for all orders within the specified date range.",
            "prevData": [
                {"refunds": 0}
            ]
        },
        {
            "id": "4be01d3b-9987-4f6d-a16a-3b2d11e622cc",
            "sql": "SELECT COUNT(DISTINCT o.customer_id) as returning_customers FROM semantic.dm_orders_shopify o JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-10T14:44:23+08:00' AND o.created_at <= '2026-01-08T14:44:23+08:00' AND c.orders_count > 1",
            "data": [
                {"returning_customers": 6}
            ],
            "unit": "Customers",
            "title": "Returning Customers",
            "action": "update",
            "column": "returning_customers",
            "format": "number",
            "layout": {
                "x": 9,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "formula": "Count of unique customers with orders_count > 1 who placed orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join orders with customers table, filter for customers with orders_count greater than 1 (returning customers), then count distinct customer IDs within the specified date range.",
            "prevData": [
                {"returning_customers": 0}
            ]
        }
    ],
    "chart": [
        {
            "id": "e8fec9f9-873d-4279-a3b4-b1d499c5a672",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as total_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [
                {
                    "order_date": "2026-01-07",
                    "total_sales": 5136.6
                },
                {
                    "order_date": "2026-01-08",
                    "total_sales": 3660
                }
            ],
            "title": "Total Sales",
            "action": "update",
            "layout": {
                "x": 6,
                "y": 4,
                "w": 6,
                "h": 8
            },
            "formula": "Sum of total_price grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, sum total_price for each date, and order chronologically to show daily sales trend.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Total Sales (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Total Sales",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "total_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "1f1d08af-d9b2-4264-a4d7-ac9e88d5642a",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  COUNT(*) as orders\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [
                {
                    "orders": 23,
                    "order_date": "2026-01-07"
                },
                {
                    "orders": 9,
                    "order_date": "2026-01-08"
                }
            ],
            "title": "Orders",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 4,
                "w": 6,
                "h": 8
            },
            "formula": "Count of orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, count orders for each date, and order chronologically to show daily order volume trend.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Orders",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Orders",
                            "type": "bar",
                            "encode": {
                                "x": "order_date",
                                "y": "orders"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "847e7fec-2bac-48da-aa2e-8d4348f58a83",
            "sql": "SELECT \n  name as product,\n  ROUND(SUM(CAST(quantity AS NUMERIC) * CAST(price AS NUMERIC)), 2) as revenue\nFROM semantic.dm_order_items_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY name\nORDER BY revenue DESC\nLIMIT 10",
            "data": [
                {
                    "product": "GIRL WITH A PEARL EARRING",
                    "revenue": 3920
                },
                {
                    "product": "Sneakers Pro",
                    "revenue": 960
                },
                {
                    "product": "VANS |\nERA 59 MOROCCAN | GEO/DRESS BLUES - 8 / blue",
                    "revenue": 0
                },
                {
                    "product": "VANS |AUTHENTIC | LO PRO | BURGANDY/WHITE - 4 / burgandy",
                    "revenue": 0
                },
                {
                    "product": "VANS | AUTHENTIC (BUTTERFLY) TRUE | WHITE / BLACK - 4 / white",
                    "revenue": 0
                },
                {
                    "product": "VANS | SK8-HI DECON (CUTOUT)| LEAVES/WHITE - 4 / white",
                    "revenue": 0
                },
                {
                    "product": "VANS | AUTHENTIC | (MULTI EYELETS) | GRADIENT/CRIMSON - 5 / red",
                    "revenue": 0
                }
            ],
            "title": "Top Products by Revenue",
            "action": "update",
            "layout": {
                "x": 6,
                "y": 12,
                "w": 6,
                "h": 8
            },
            "formula": "Sum of (quantity * price) grouped by product name, limited to top 10 products",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group order line items by product name, calculate revenue as quantity multiplied by price for each product, sort by revenue in descending order, and limit to top 10 products.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Product",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Revenue",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Revenue",
                            "type": "bar",
                            "encode": {
                                "x": "product",
                                "y": "revenue"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "14174828-cb2b-42fc-9261-595246023c2c",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_discounts AS NUMERIC)), 2) as discounts,\n  ROUND(COALESCE(SUM(CAST(raw->'refunds'->0->>'subtotal' AS NUMERIC)), 0), 2) as refunds\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [
                {
                    "refunds": 0,
                    "discounts": 0,
                    "order_date": "2026-01-07"
                },
                {
                    "refunds": 0,
                    "discounts": 0,
                    "order_date": "2026-01-08"
                }
            ],
            "title": "Discounts & Refunds",
            "action": "update",
            "layout": {
                "x": 6,
                "y": 20,
                "w": 6,
                "h": 8
            },
            "formula": "Sum of discounts and refunds grouped by date, displayed as area chart",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, sum total_discounts and extract refund amounts from JSON raw data for each date, displaying both metrics as area trends.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Amount (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Discounts",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "discounts"
                            },
                            "areaStyle": {}
                        },
                        {
                            "name": "Refunds",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "refunds"
                            },
                            "areaStyle": {}
                        }
                    ]
                }
            }
        },
        {
            "id": "46927465-8dca-4053-9bd5-1316fcd7da2a",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)) / COUNT(*), 2) as aov\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [
                {
                    "aov": 223.33,
                    "order_date": "2026-01-07"
                },
                {
                    "aov": 406.67,
                    "order_date": "2026-01-08"
                }
            ],
            "title": "AOV",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 12,
                "w": 6,
                "h": 8
            },
            "formula": "Average Order Value = Total Sales / Number of Orders, calculated daily",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, calculate daily Average Order Value by dividing total_price by order count, and order chronologically to show AOV trend.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "AOV (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "AOV",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "aov"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "0814406b-1504-44e4-b8a3-3a94676d0077",
            "sql": "\nSELECT \n  CASE WHEN c.orders_count = 1 THEN 'New Customer Sales' ELSE 'Returning Customer Sales' END as customer_type,\n  ROUND(SUM(CAST(o.total_price AS NUMERIC)), 2) as sales\nFROM semantic.dm_orders_shopify o\nJOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:44:23+08:00' AND o.created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY customer_type\nORDER BY sales DESC\n",
            "data": [
                {
                    "sales": 7986.85,
                    "customer_type": "Returning Customer Sales"
                },
                {
                    "sales": 809.75,
                    "customer_type": "New Customer Sales"
                }
            ],
            "title": "New Sales vs Returning Sales Share",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 20,
                "w": 6,
                "h": 8
            },
            "formula": "Sales distribution between new customers (orders_count = 1) and returning customers (orders_count > 1)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join orders with customers table, classify customers as new (orders_count = 1) or returning (orders_count > 1), sum sales by customer type, and sort by sales descending.",
            "chart_config": {
                "pie": {
                    "series": [
                        {
                            "name": "Sales Share",
                            "type": "pie",
                            "encode": {
                                "value": "sales",
                                "itemName": "customer_type"
                            }
                        }
                    ]
                }
            }
        }
    ]
}

export const MarketingFocus = {
    "kpi": [
        {
            "id": "0f3d2443-d28d-4d68-b586-2d278765d6a6",
            "title": "Ad Spend",
            "sql": "SELECT COALESCE(SUM(cost), 0) as ad_spend FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Sum of all advertising costs from Google Ads campaigns during the selected period",
            "column": "ad_spend",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"ad_spend": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Sum the cost field from Google Ads campaigns table where report_date falls within the selected period and record_type is CAMPAIGN.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"ad_spend": 0}
            ]
        },
        {
            "id": "c4951cab-be07-4f4c-a8af-9500239e5235",
            "title": "Ad Clicks",
            "sql": "SELECT COALESCE(SUM(clicks), 0) as ad_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Total number of clicks on ads during the selected period",
            "column": "ad_clicks",
            "format": "number",
            "unit": "Clicks",
            "data": [
                {"ad_clicks": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Sum the clicks field from Google Ads campaigns table where report_date falls within the selected period and record_type is CAMPAIGN.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 3,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"ad_clicks": 0}
            ]
        },
        {
            "id": "5b73ec18-c7e2-48ea-a578-e679b9a26f9d",
            "title": "CTR",
            "sql": "SELECT CASE WHEN SUM(impressions) > 0 THEN SUM(clicks)::numeric / SUM(impressions)::numeric ELSE 0 END as ctr FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Click-Through Rate = Total Clicks / Total Impressions. Measures ad creative and targeting quality",
            "column": "ctr",
            "format": "percent",
            "unit": "%",
            "data": [
                {"ctr": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate Click-Through Rate by dividing total clicks by total impressions from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range and handle division by zero using CASE WHEN statement.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 6,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"ctr": 0}
            ]
        },
        {
            "id": "b8eeaa43-8731-40a4-8f73-523ea72a8b41",
            "title": "CPC",
            "sql": "SELECT CASE WHEN SUM(clicks) > 0 THEN SUM(cost)::numeric / SUM(clicks)::numeric ELSE 0 END as cpc FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Cost Per Click = Total Ad Spend / Total Clicks. Measures traffic acquisition cost",
            "column": "cpc",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"cpc": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate Cost Per Click by dividing total cost by total clicks from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range and handle division by zero using CASE WHEN statement.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 9,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"cpc": 0}
            ]
        },
        {
            "id": "7329079d-9606-4556-a7ac-d27e525adc11",
            "title": "Conversions",
            "sql": "SELECT COALESCE(SUM(conversions), 0) as total_conversions FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Total number of conversions (purchases) attributed to ads during the selected period",
            "column": "total_conversions",
            "format": "number",
            "unit": "Conversions",
            "data": [
                {"total_conversions": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Sum the conversions field from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 0,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"total_conversions": 0}
            ]
        },
        {
            "id": "974ad93b-101c-495f-9726-6231aeab3cca",
            "title": "CPA",
            "sql": "SELECT CASE WHEN SUM(conversions) > 0 THEN SUM(cost)::numeric / SUM(conversions)::numeric ELSE 0 END as cpa FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Cost Per Acquisition = Total Ad Spend / Total Conversions. Measures customer acquisition cost",
            "column": "cpa",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"cpa": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate Cost Per Acquisition by dividing total cost by total conversions from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range and handle division by zero using CASE WHEN statement.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 3,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"cpa": 0}
            ]
        },
        {
            "id": "43dedc01-0859-4c40-914d-379789599a10",
            "title": "ROAS",
            "sql": "SELECT CASE WHEN SUM(cost) > 0 THEN SUM(conversion_value)::numeric / SUM(cost)::numeric ELSE 0 END as roas FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Return on Ad Spend = Total Conversion Value / Total Ad Spend. Measures revenue return per dollar spent",
            "column": "roas",
            "format": "number",
            "unit": "x",
            "data": [
                {"roas": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate Return on Ad Spend by dividing total conversion value by total cost from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range and handle division by zero using CASE WHEN statement.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 6,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"roas": 0}
            ]
        },
        {
            "id": "2f6d383c-dd0d-4cb6-a313-d87b0d7f15cb",
            "title": "ROI",
            "sql": "SELECT CASE WHEN SUM(cost) > 0 THEN (SUM(conversion_value)::numeric - SUM(cost)::numeric) / SUM(cost)::numeric ELSE 0 END as roi FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "formula": "Return on Investment = (Total Conversion Value - Total Ad Spend) / Total Ad Spend. Measures profit-based return",
            "column": "roi",
            "format": "percent",
            "unit": "%",
            "data": [
                {"roi": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate Return on Investment by dividing the difference of total conversion value and total cost by total cost from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range and handle division by zero using CASE WHEN statement.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 9,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"roi": 0}
            ]
        },
        {
            "id": "4fb25b26-4ea8-4147-b701-ad355bde5df0",
            "title": "Signal Loss",
            "sql": "WITH ad_clicks AS (SELECT COALESCE(SUM(clicks), 0) as total_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), landing_views AS (SELECT COUNT(*) as total_views FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00' AND event_name = 'page_viewed' AND referrer_url LIKE '%google%') SELECT CASE WHEN ad_clicks.total_clicks > 0 THEN (ad_clicks.total_clicks - landing_views.total_views)::numeric / ad_clicks.total_clicks::numeric ELSE 0 END as signal_loss FROM ad_clicks, landing_views",
            "formula": "Signal Loss Rate = (Ad Clicks - Landing Page Views) / Ad Clicks. Measures tracking quality and data discrepancy between ad platform and Shopify",
            "column": "signal_loss",
            "format": "percent",
            "unit": "%",
            "data": [
                {"signal_loss": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Compare total ad clicks from Google Ads campaigns table (where record_type is CAMPAIGN) with total page view events from Shopify pixel events table (where event_name is page_viewed and referrer contains 'google'). Filter both sources by selected date range. Calculate loss rate as difference between clicks and views divided by total clicks, handling division by zero.",
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 4,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"signal_loss": 0}
            ]
        }
    ],
    "chart": [
        {
            "id": "2235e1c0-f2ac-4166-9ab2-2eaba14de0a6",
            "title": "Marketing Funnel",
            "sql": "WITH ad_metrics AS (SELECT SUM(impressions) as impressions, SUM(clicks) as clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), pixel_metrics AS (SELECT COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END) as landing_views, COUNT(CASE WHEN event_name = 'product_added_to_cart' THEN 1 END) as add_to_cart, COUNT(CASE WHEN event_name = 'checkout_started' THEN 1 END) as checkouts, COUNT(CASE WHEN event_name = 'checkout_completed' THEN 1 END) as purchases FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00') SELECT 'Impressions' as stage, COALESCE(ad_metrics.impressions, 0) as value FROM ad_metrics UNION ALL SELECT 'Clicks' as stage, COALESCE(ad_metrics.clicks, 0) as value FROM ad_metrics UNION ALL SELECT 'Landing Page Views' as stage, COALESCE(pixel_metrics.landing_views, 0) as value FROM pixel_metrics UNION ALL SELECT 'Add to Cart' as stage, COALESCE(pixel_metrics.add_to_cart, 0) as value FROM pixel_metrics UNION ALL SELECT 'Checkouts' as stage, COALESCE(pixel_metrics.checkouts, 0) as value FROM pixel_metrics UNION ALL SELECT 'Purchases' as stage, COALESCE(pixel_metrics.purchases, 0) as value FROM pixel_metrics ORDER BY value DESC",
            "formula": "Funnel stages: Impressions → Clicks → Landing Page Views → Add to Cart → Checkouts → Purchases. Shows where drop-off occurs in the customer journey",
            "data": [
                {
                    "stage": "Landing Page Views",
                    "value": 15
                },
                {
                    "stage": "Purchases",
                    "value": 1
                },
                {
                    "stage": "Impressions",
                    "value": 0
                },
                {
                    "stage": "Clicks",
                    "value": 0
                },
                {
                    "stage": "Add to Cart",
                    "value": 0
                },
                {
                    "stage": "Checkouts",
                    "value": 0
                }
            ],
            "chart_config": {
                "funnel": {
                    "series": [
                        {
                            "name": "Marketing Funnel",
                            "type": "funnel",
                            "encode": {
                                "value": "value",
                                "itemName": "stage"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Retrieve funnel stage metrics by aggregating data from two sources: (1) From Google Ads campaigns table, extract total impressions and clicks for records where record_type is CAMPAIGN and report_date falls within the selected period. (2) From Shopify pixel events table, count page view, add-to-cart, checkout start, and checkout complete events where occurred_at falls within the selected period. Combine all metrics into a single result set with stage names and corresponding values, ordered by value in descending order to show funnel progression.",
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 6,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "8fbd3c91-ef59-471d-9716-cc038c465a7d",
            "title": "Signal Loss Analysis",
            "sql": "WITH ad_clicks AS (SELECT COALESCE(SUM(clicks), 0) as total_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), landing_views AS (SELECT COUNT(*) as total_views FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00' AND event_name = 'page_viewed') SELECT 'Ad Clicks' as metric, ad_clicks.total_clicks as value FROM ad_clicks UNION ALL SELECT 'Landing Page Views' as metric, landing_views.total_views as value FROM landing_views UNION ALL SELECT 'Signal Loss' as metric, CASE WHEN ad_clicks.total_clicks > 0 THEN ad_clicks.total_clicks - landing_views.total_views ELSE 0 END as value FROM ad_clicks, landing_views",
            "formula": "Compares Ad Clicks vs Landing Page Views to identify tracking loss. Shows attribution and pixel tracking quality",
            "data": [
                {
                    "value": 0,
                    "metric": "Ad Clicks"
                },
                {
                    "value": 15,
                    "metric": "Landing Page Views"
                },
                {
                    "value": 0,
                    "metric": "Signal Loss"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Metric",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Count",
                            "type": "bar",
                            "encode": {
                                "x": "metric",
                                "y": "value"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Retrieve ad clicks from Google Ads campaigns table where record_type is CAMPAIGN and report_date falls within the selected period. Retrieve landing page views from Shopify pixel events table where event_name is page_viewed and occurred_at falls within the selected period. Calculate signal loss as the difference between ad clicks and landing page views. Present three metrics: total ad clicks, total landing page views, and signal loss count. Combine results from multiple CTEs to display comparative analysis.",
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 14,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "3b780fa7-b49d-4b36-8307-2cc44ac5f208",
            "title": "Add to Cart Rate Trend",
            "sql": "SELECT DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') as report_date, CASE WHEN COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END) > 0 THEN COUNT(CASE WHEN event_name = 'product_added_to_cart' THEN 1 END)::numeric / COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END)::numeric ELSE 0 END as atc_rate FROM semantic.dm_shopify_pixel_events GROUP BY DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') ORDER BY report_date",
            "formula": "Daily ATC Rate = Add to Cart Events / Landing Page Views. Shows ad-driven traffic intent quality over time",
            "data": [
                {
                    "atc_rate": 0,
                    "report_date": "2026-01-07"
                },
                {
                    "atc_rate": 0,
                    "report_date": "2026-01-08"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "ATC Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "ATC Rate",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "atc_rate"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Extract daily data from Shopify pixel events table where occurred_at falls within the selected period. Group events by date using Asia/Shanghai timezone. For each date, calculate Add-to-Cart rate by dividing count of product_added_to_cart events by count of page_viewed events. Handle division by zero using CASE WHEN. Order results chronologically by date to show daily trends.",
            "layout": {
                "x": 6,
                "y": 4,
                "w": 6,
                "h": 8
            },
            "sources": [
                "Shopify"
            ]
        },
        {
            "id": "ebbb97ab-a044-4359-9b60-c8baba0b46d2",
            "title": "Ad Spend Trend",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, COALESCE(SUM(cost), 0) as ad_spend FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.ad_spend, 0) as ad_spend FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "formula": "Daily sum of advertising costs. Shows spending patterns and identifies budget anomalies or sudden changes",
            "data": [
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-08"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-09"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-10"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-11"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-12"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-13"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-14"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-15"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-16"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-17"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-18"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-19"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-20"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-21"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-22"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-23"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-24"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-25"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-26"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-27"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-28"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-29"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-30"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2025-12-31"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-01"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-02"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-03"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-04"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-05"
                },
                {
                    "ad_spend": 0,
                    "report_date": "2026-01-06"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "Ad Spend",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Ad Spend",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "ad_spend"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily ad spend from Google Ads campaigns table where report_date matches and record_type is CAMPAIGN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero spend. Order chronologically by date.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 6,
                "y": 12,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "e21a1e71-b376-477a-b30c-d0ae55014874",
            "title": "ROAS Trend",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(cost) > 0 THEN SUM(conversion_value)::numeric / SUM(cost)::numeric ELSE 0 END as roas FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.roas, 0) as roas FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "formula": "Daily ROAS = Daily Conversion Value / Daily Ad Spend. Shows return trend and identifies when performance improves or declines",
            "data": [
                {
                    "roas": 0,
                    "report_date": "2025-12-08"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-09"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-10"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-11"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-12"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-13"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-14"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-15"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-16"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-17"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-18"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-19"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-20"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-21"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-22"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-23"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-24"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-25"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-26"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-27"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-28"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-29"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-30"
                },
                {
                    "roas": 0,
                    "report_date": "2025-12-31"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-01"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-02"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-03"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-04"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-05"
                },
                {
                    "roas": 0,
                    "report_date": "2026-01-06"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "ROAS",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}x"}
                        }
                    ],
                    "series": [
                        {
                            "name": "ROAS",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "roas"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily ROAS from Google Ads campaigns table by calculating conversion value divided by cost where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero ROAS. Order chronologically by date.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 0,
                "y": 22,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "24f2cc8f-a986-4fb6-b7cf-85125aa95818",
            "title": "CTR Trend",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(impressions) > 0 THEN SUM(clicks)::numeric / SUM(impressions)::numeric ELSE 0 END as ctr FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.ctr, 0) as ctr FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "formula": "Daily CTR = Daily Clicks / Daily Impressions. Shows ad creative and targeting effectiveness over time",
            "data": [
                {
                    "ctr": 0,
                    "report_date": "2025-12-08"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-09"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-10"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-11"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-12"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-13"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-14"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-15"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-16"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-17"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-18"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-19"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-20"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-21"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-22"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-23"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-24"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-25"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-26"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-27"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-28"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-29"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-30"
                },
                {
                    "ctr": 0,
                    "report_date": "2025-12-31"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-01"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-02"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-03"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-04"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-05"
                },
                {
                    "ctr": 0,
                    "report_date": "2026-01-06"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "CTR",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CTR",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "ctr"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily CTR from Google Ads campaigns table by calculating clicks divided by impressions where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero CTR. Order chronologically by date.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 0,
                "y": 30,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "d2a69066-bfb4-43a1-bb53-cb9eed0f2d73",
            "title": "CPC Trend",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(clicks) > 0 THEN SUM(cost)::numeric / SUM(clicks)::numeric ELSE 0 END as cpc FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.cpc, 0) as cpc FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "formula": "Daily CPC = Daily Ad Spend / Daily Clicks. Shows whether traffic is becoming more expensive due to competition or targeting issues",
            "data": [
                {
                    "cpc": 0,
                    "report_date": "2025-12-08"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-09"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-10"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-11"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-12"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-13"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-14"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-15"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-16"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-17"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-18"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-19"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-20"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-21"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-22"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-23"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-24"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-25"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-26"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-27"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-28"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-29"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-30"
                },
                {
                    "cpc": 0,
                    "report_date": "2025-12-31"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-01"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-02"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-03"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-04"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-05"
                },
                {
                    "cpc": 0,
                    "report_date": "2026-01-06"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "CPC",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CPC",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "cpc"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily CPC from Google Ads campaigns table by calculating cost divided by clicks where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero CPC. Order chronologically by date.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 6,
                "y": 20,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "68a54b7a-821f-4346-925f-7da4beb9037e",
            "title": "Conversion Rate Trend",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(clicks) > 0 THEN SUM(conversions)::numeric / SUM(clicks)::numeric ELSE 0 END as conversion_rate FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.conversion_rate, 0) as conversion_rate FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "formula": "Daily Conversion Rate = Daily Conversions / Daily Clicks. Shows click quality and whether traffic converts over time",
            "data": [
                {
                    "report_date": "2025-12-08",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-09",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-10",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-11",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-12",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-13",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-14",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-15",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-16",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-17",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-18",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-19",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-20",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-21",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-22",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-23",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-24",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-25",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-26",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-27",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-28",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-29",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-30",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2025-12-31",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-01",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-02",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-03",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-04",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-05",
                    "conversion_rate": 0
                },
                {
                    "report_date": "2026-01-06",
                    "conversion_rate": 0
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "Conversion Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Conversion Rate",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "conversion_rate"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily conversion rate from Google Ads campaigns table by calculating conversions divided by clicks where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero conversion rate. Order chronologically by date.",
            "sources": [
                "Google Ads"
            ],
            "layout": {
                "x": 6,
                "y": 28,
                "w": 6,
                "h": 8
            }
        }
    ]
}

export const CustomerRetention = {
    "kpi": [
        {
            "id": "3f20000d-5ffb-4a99-9db0-71c764dff18b",
            "title": "Total Customers",
            "sql": "\nSELECT COUNT(DISTINCT c.customer_id) as total_customers\nFROM semantic.dm_customers_shopify c\nWHERE c.created_at >= '2025-12-10T14:43:01+08:00' AND c.created_at <= '2026-01-08T14:43:01+08:00'\nLIMIT 1\n",
            "formula": "Count of distinct customers created in the date range",
            "column": "total_customers",
            "format": "number",
            "unit": "Customers",
            "data": [
                {"total_customers": 13}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Count distinct customers created within the specified date range.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"total_customers": 0}
            ]
        },
        {
            "id": "e5fab857-b438-4c07-82ab-bda2bfe7796a",
            "title": "New Customers",
            "sql": "\nSELECT COUNT(DISTINCT c.customer_id) as new_customers\nFROM semantic.dm_customers_shopify c\nINNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\nWHERE c.created_at >= '2025-12-10T14:43:01+08:00' AND c.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nLIMIT 1\n",
            "formula": "Count of customers who made their first purchase in the date range",
            "column": "new_customers",
            "format": "number",
            "unit": "Customers",
            "data": [
                {"new_customers": 10}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Count distinct customers who placed their first order with non-cancelled financial status within the specified date range.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 3,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"new_customers": 0}
            ]
        },
        {
            "id": "7237fe18-3dd6-42f9-ab9d-a0fe20e336cb",
            "title": "Returning Customers",
            "sql": "\nSELECT COUNT(DISTINCT CASE WHEN orders_count > 1 THEN customer_id END) as returning_customers\nFROM semantic.dm_customers_shopify\nWHERE created_at >= '2025-12-10T14:43:01+08:00' AND created_at <= '2026-01-08T14:43:01+08:00'\nLIMIT 1\n",
            "formula": "Count of customers with more than 1 order in the date range",
            "column": "returning_customers",
            "format": "number",
            "unit": "Customers",
            "data": [
                {"returning_customers": 6}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Count distinct customers with more than one order created within the specified date range.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"returning_customers": 0}
            ]
        },
        {
            "id": "515bfd3a-493c-46a9-a4a4-ce617fc92338",
            "title": "Customer Lifetime Value (CLTV)",
            "sql": "\nSELECT \n  SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as cltv\nFROM semantic.dm_orders_shopify o\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nLIMIT 1\n",
            "formula": "Total Revenue / Unique Customers in the date range",
            "column": "cltv",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"cltv": 879.66}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate total revenue divided by distinct customers, excluding cancelled orders.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 9,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"cltv": null}
            ]
        },
        {
            "id": "489d2298-26bc-44c6-8852-7b30e75de6f1",
            "title": "Repeat Purchase Rate",
            "sql": "\nSELECT \n  COUNT(DISTINCT CASE WHEN orders_count > 1 THEN customer_id END)::float / NULLIF(COUNT(DISTINCT customer_id), 0) as repeat_purchase_rate\nFROM semantic.dm_customers_shopify\nWHERE created_at >= '2025-12-10T14:43:01+08:00' AND created_at <= '2026-01-08T14:43:01+08:00'\nLIMIT 1\n",
            "formula": "Returning Customers / Total Customers in the date range",
            "column": "repeat_purchase_rate",
            "format": "percent",
            "unit": "%",
            "data": [
                {"repeat_purchase_rate": 0.461538461538462}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate percentage of customers with more than one order divided by total customers with non-cancelled orders.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"repeat_purchase_rate": null}
            ]
        },
        {
            "id": "002f5b69-9ed2-4d31-b403-56946bb92562",
            "title": "Average Order Value (AOV)",
            "sql": "\nSELECT \n  SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0) as aov\nFROM semantic.dm_orders_shopify o\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nLIMIT 1\n",
            "formula": "Total Revenue / Total Orders in the date range",
            "column": "aov",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"aov": 274.89375}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate total revenue divided by total count of non-cancelled orders.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 9,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"aov": null}
            ]
        },
        {
            "id": "d6b93cc4-1939-4f04-aef3-16fb0b8aa497",
            "title": "Customer Lifetime Value (Profit)",
            "sql": "\nSELECT \n  (SUM(o.total_price) - SUM(o.total_tax) - SUM(o.total_discounts)) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as clv_profit\nFROM semantic.dm_orders_shopify o\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nLIMIT 1\n",
            "formula": "Net Revenue (Total Price - Tax - Discounts) / Unique Customers in the date range",
            "column": "clv_profit",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"clv_profit": 879.66}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate net revenue (total price minus tax and discounts) divided by distinct customers with non-cancelled orders.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"clv_profit": null}
            ]
        },
        {
            "id": "efbcdf65-8e75-4c69-b0e7-588767075174",
            "title": "CAC (Order)",
            "sql": "\nSELECT \n  COALESCE(SUM(gac.cost), 0) / NULLIF(COUNT(DISTINCT o.order_id), 0) as cac_order\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(gac.report_date) >= '2025-12-07'::date\n  AND DATE(gac.report_date) < '2026-01-06'::date\n  AND gac.record_type = 'CAMPAIGN'\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nGROUP BY o.customer_id\nLIMIT 1\n",
            "formula": "Total Advertising Spend / Total Orders in the date range",
            "column": "cac_order",
            "format": "currency",
            "unit": "USD",
            "data": [
                {"cac_order": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate total advertising spend from Google Ads divided by total non-cancelled orders.",
            "sources": [
                "Shopify",
                "Google Ads"
            ],
            "layout": {
                "x": 3,
                "y": 2,
                "w": 3,
                "h": 2
            },
            "prevData": []
        },
        {
            "id": "567acbc6-7703-48bc-8e23-0325e8ae4043",
            "title": "LTV to CAC Ratio (Order)",
            "sql": "\nSELECT \n  (SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0)) / \n  NULLIF(COALESCE(SUM(gac.cost), 0) / NULLIF(COUNT(DISTINCT o.order_id), 0), 0) as ltv_cac_ratio\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(gac.report_date) >= '2025-12-07'::date\n  AND DATE(gac.report_date) < '2026-01-06'::date\n  AND gac.record_type = 'CAMPAIGN'\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nLIMIT 1\n",
            "formula": "Average Order Value / Customer Acquisition Cost (Order basis)",
            "column": "ltv_cac_ratio",
            "format": "number",
            "unit": "Ratio",
            "data": [
                {"ltv_cac_ratio": null}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate average order value divided by customer acquisition cost per order. This ratio shows how efficiently marketing spend converts to customer value.",
            "sources": [
                "Shopify",
                "Google Ads"
            ],
            "layout": {
                "x": 0,
                "y": 4,
                "w": 3,
                "h": 2
            },
            "prevData": [
                {"ltv_cac_ratio": null}
            ]
        }
    ],
    "chart": [
        {
            "id": "66d2b497-ad3b-4313-b49a-3e8fb67a2039",
            "title": "Repeat Purchase Rate by Cohort (Week)",
            "sql": "\nWITH first_order_week AS (\n  SELECT \n    c.customer_id,\n    DATE_TRUNC('week', c.created_at AT TIME ZONE 'Asia/Shanghai')::date as cohort_week,\n    DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as order_week,\n    ROW_NUMBER() OVER (PARTITION BY c.customer_id ORDER BY o.created_at) as order_seq\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n)\nSELECT \n  cohort_week::text as cohort_week,\n  order_week::text as order_week,\n  COUNT(DISTINCT CASE WHEN order_seq > 1 THEN customer_id END)::float / NULLIF(COUNT(DISTINCT customer_id), 0) * 100 as repeat_purchase_rate\nFROM first_order_week\nGROUP BY cohort_week, order_week\nORDER BY cohort_week, order_week\nLIMIT 100\n",
            "formula": "Percentage of customers from a cohort week that made repeat purchases in each subsequent week",
            "data": [
                {
                    "order_week": "2026-01-05",
                    "cohort_week": "2026-01-05",
                    "repeat_purchase_rate": 60
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Cohort Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Week",
                            "type": "category"
                        }
                    ],
                    "series": [
                        {
                            "name": "Repeat Purchase Rate (%)",
                            "type": "heatmap",
                            "encode": {
                                "x": "cohort_week",
                                "y": "order_week",
                                "value": "repeat_purchase_rate"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Group customers by their cohort week (week of first order), then calculate the percentage of repeat customers (those with more than one order) for each subsequent order week. This creates a cohort analysis heatmap showing retention and repeat purchase patterns.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 6,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "32a8dd2d-fe7b-439d-941c-fce5d5317c6b",
            "title": "New vs Returning Customers Trend",
            "sql": "\nWITH daily_data AS (\n  SELECT \n    DATE(c.created_at AT TIME ZONE 'Asia/Shanghai') as date,\n    COUNT(DISTINCT c.customer_id) as new_customers,\n    COUNT(DISTINCT CASE WHEN c.orders_count > 1 THEN c.customer_id END) as returning_customers\n  FROM semantic.dm_customers_shopify c\n  GROUP BY DATE(c.created_at AT TIME ZONE 'Asia/Shanghai')\n)\nSELECT \n  date::text,\n  new_customers,\n  returning_customers\nFROM daily_data\nORDER BY date\nLIMIT 100\n",
            "formula": "Daily count of new customers and returning customers (with orders_count > 1) over time",
            "data": [
                {
                    "date": "2026-01-07",
                    "new_customers": 13,
                    "returning_customers": 6
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Customer Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Customers",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "new_customers"
                            }
                        },
                        {
                            "name": "Returning Customers",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "returning_customers"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate daily count of new customers and returning customers (those with orders_count greater than 1) based on customer creation date. Display trend over time to show customer acquisition and retention patterns.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 28,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "3a1f01cf-94b8-46f7-9823-71497a98eb35",
            "title": "CLTV Distribution",
            "sql": "\nWITH customer_ltv AS (\n  SELECT \n    c.customer_id,\n    SUM(o.total_price) as customer_ltv\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY c.customer_id\n),\nltv_buckets AS (\n  SELECT \n    CASE \n      WHEN customer_ltv < 100 THEN '$0-100'\n      WHEN customer_ltv < 250 THEN '$100-250'\n      WHEN customer_ltv < 500 THEN '$250-500'\n      WHEN customer_ltv < 1000 THEN '$500-1000'\n      ELSE '$1000+'\n    END as ltv_bucket,\n    COUNT(DISTINCT customer_id) as customer_count\n  FROM customer_ltv\n  GROUP BY ltv_bucket\n)\nSELECT \n  ltv_bucket,\n  customer_count\nFROM ltv_buckets\nORDER BY \n  CASE \n    WHEN ltv_bucket = '$0-100' THEN 1\n    WHEN ltv_bucket = '$100-250' THEN 2\n    WHEN ltv_bucket = '$250-500' THEN 3\n    WHEN ltv_bucket = '$500-1000' THEN 4\n    ELSE 5\n  END\nLIMIT 10\n",
            "formula": "Distribution of customers across different Customer Lifetime Value ranges",
            "data": [
                {
                    "ltv_bucket": "$0-100",
                    "customer_count": 1
                },
                {
                    "ltv_bucket": "$100-250",
                    "customer_count": 1
                },
                {
                    "ltv_bucket": "$250-500",
                    "customer_count": 3
                },
                {
                    "ltv_bucket": "$500-1000",
                    "customer_count": 3
                },
                {
                    "ltv_bucket": "$1000+",
                    "customer_count": 2
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "CLTV Bucket",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Customer Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Customer Count",
                            "type": "bar",
                            "encode": {
                                "x": "ltv_bucket",
                                "y": "customer_count"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate total lifetime value for each customer by summing all their non-cancelled orders, then segment customers into CLTV buckets ($0-100, $100-250, $250-500, $500-1000, $1000+). Count customers in each bucket to show distribution.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 14,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "fb12b78e-d436-4639-8c81-71d3eda10832",
            "title": "AOV vs Repeat Purchase Rate by Customer",
            "sql": "\nWITH customer_metrics AS (\n  SELECT \n    c.customer_id,\n    AVG(o.total_price) as avg_order_value,\n    CAST(COUNT(CASE WHEN o.order_id IS NOT NULL THEN 1 END) > 1 AS INT) as is_returning,\n    COUNT(DISTINCT o.order_id) as total_orders,\n    SUM(o.total_price) as total_spent\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY c.customer_id\n)\nSELECT \n  ROUND(avg_order_value, 2) as aov,\n  is_returning,\n  ROW_NUMBER() OVER (ORDER BY customer_id) as customer_id\nFROM customer_metrics\nLIMIT 300\n",
            "formula": "Scatter plot of Average Order Value against repeat purchase indicator (0=New Customer, 1=Returning Customer)",
            "data": [
                {
                    "aov": 204.44,
                    "customer_id": 1,
                    "is_returning": 1
                },
                {
                    "aov": 305.57,
                    "customer_id": 2,
                    "is_returning": 1
                },
                {
                    "aov": 289.9,
                    "customer_id": 3,
                    "is_returning": 0
                },
                {
                    "aov": 198.93,
                    "customer_id": 4,
                    "is_returning": 1
                },
                {
                    "aov": 299.9,
                    "customer_id": 5,
                    "is_returning": 0
                },
                {
                    "aov": 404.82,
                    "customer_id": 6,
                    "is_returning": 1
                },
                {
                    "aov": 99.95,
                    "customer_id": 7,
                    "is_returning": 0
                },
                {
                    "aov": 356.86,
                    "customer_id": 8,
                    "is_returning": 1
                },
                {
                    "aov": 120,
                    "customer_id": 9,
                    "is_returning": 0
                },
                {
                    "aov": 154.61,
                    "customer_id": 10,
                    "is_returning": 1
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Average Order Value (USD)",
                        "type": "value"
                    },
                    "yAxis": [
                        {
                            "name": "Is Returning (0=New, 1=Returning)",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Customer AOV Distribution",
                            "type": "scatter",
                            "encode": {
                                "x": "aov",
                                "y": "is_returning"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "For each customer, calculate their average order value and determine if they are a returning customer (more than one order). Create a scatter plot showing the relationship between AOV and repeat purchase status (0=New Customer, 1=Returning Customer).",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 4,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "feac6b89-17a7-44b2-a0b9-a27977b8ada3",
            "title": "New vs Returning Sales Share",
            "sql": "\nWITH customer_order_seq AS (\n  SELECT \n    o.order_id,\n    o.customer_id,\n    o.total_price,\n    ROW_NUMBER() OVER (PARTITION BY o.customer_id ORDER BY o.created_at) as order_seq\n  FROM semantic.dm_orders_shopify o\n  WHERE o.financial_status != 'cancelled'\n)\nSELECT \n  CASE \n    WHEN order_seq = 1 THEN 'New Customer Sales'\n    ELSE 'Returning Customer Sales'\n  END as customer_type,\n  SUM(total_price) as sales_amount\nFROM customer_order_seq\nGROUP BY CASE \n  WHEN order_seq = 1 THEN 'New Customer Sales'\n  ELSE 'Returning Customer Sales'\nEND\nLIMIT 10\n",
            "formula": "Revenue distribution between new customer first orders and returning customer repeat orders",
            "data": [
                {
                    "sales_amount": 6944.2,
                    "customer_type": "Returning Customer Sales"
                },
                {
                    "sales_amount": 1852.4,
                    "customer_type": "New Customer Sales"
                }
            ],
            "chart_config": {
                "pie": {
                    "series": [
                        {
                            "name": "Sales Share",
                            "type": "pie",
                            "encode": {
                                "value": "sales_amount",
                                "itemName": "customer_type"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Identify each customer's first order (order_seq = 1) as new customer sales and subsequent orders as returning customer sales. Sum total revenue for each category and display as pie chart showing revenue distribution.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 22,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "bc773a58-fac6-4fb2-83f9-2e3f9c191b0b",
            "title": "Customer Migration: New → Returning",
            "sql": "\nWITH customer_journey AS (\n  SELECT \n    c.customer_id,\n    COUNT(DISTINCT o.order_id) as order_count,\n    SUM(o.total_price) as total_revenue\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY c.customer_id\n)\nSELECT \n  CASE WHEN order_count = 1 THEN 'New Customers' ELSE 'Converted Users' END as source,\n  CASE WHEN order_count = 1 THEN 'One-Time Buyer' ELSE 'Repeat Buyer' END as target,\n  COUNT(DISTINCT customer_id) as customer_flow\nFROM customer_journey\nGROUP BY source, target\nLIMIT 50\n",
            "formula": "Flow visualization showing customer progression from new customers (first purchase) to returning/repeat customers",
            "data": [
                {
                    "source": "Converted Users",
                    "target": "Repeat Buyer",
                    "customer_flow": 6
                },
                {
                    "source": "New Customers",
                    "target": "One-Time Buyer",
                    "customer_flow": 4
                }
            ],
            "chart_config": {
                "sankey": {
                    "series": [
                        {
                            "name": "Customer Flow",
                            "type": "sankey",
                            "encode": {
                                "value": "customer_flow",
                                "source": "source",
                                "target": "target"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Classify customers as new (one order) or converted (multiple orders), then create a Sankey flow diagram showing the progression from new customers to repeat buyers. Count customers in each transition path.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 12,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "6894aef3-44bf-40f0-bd9a-d8fa4fcd4318",
            "title": "LTV/CAC Ratio Over Time (Monthly)",
            "sql": "\nWITH monthly_metrics AS (\n  SELECT \n    DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as month,\n    COUNT(DISTINCT o.customer_id) as unique_customers,\n    COUNT(DISTINCT o.order_id) as total_orders,\n    SUM(o.total_price) as total_revenue,\n    SUM(o.total_price) / COUNT(DISTINCT o.order_id) as aov,\n    SUM(o.total_price) / COUNT(DISTINCT o.customer_id) as customer_ltv\n  FROM semantic.dm_orders_shopify o\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai')\n)\nSELECT \n  month::text,\n  ROUND(customer_ltv / NULLIF(1, 0)::numeric, 2) as ltv_metric,\n  ROUND(COALESCE(customer_ltv, 0) / NULLIF(50, 0), 2) as ltv_cac_ratio\nFROM monthly_metrics\nORDER BY month\nLIMIT 12\n",
            "formula": "Monthly LTV to CAC ratio showing customer lifetime value efficiency relative to acquisition cost over time",
            "data": [
                {
                    "month": "2026-01-01",
                    "ltv_metric": 879.66,
                    "ltv_cac_ratio": 17.59
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Month",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "LTV/CAC Ratio",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "LTV/CAC Ratio",
                            "type": "line",
                            "encode": {
                                "x": "month",
                                "y": "ltv_cac_ratio"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Group orders by month and calculate monthly customer lifetime value (total revenue per customer). Divide by a fixed CAC estimate to show the LTV/CAC ratio trend over time, indicating marketing efficiency.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 30,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "c3742ed6-2d66-404b-a88f-9c4bd17871a5",
            "title": "Customer Lifetime Value (Profit) - New vs Returning",
            "sql": "\nWITH customer_order_seq AS (\n  SELECT \n    c.customer_id,\n    CASE WHEN ROW_NUMBER() OVER (PARTITION BY c.customer_id ORDER BY o.created_at) = 1 THEN 'New Customer' ELSE 'Returning Customer' END as customer_type,\n    o.total_price,\n    o.total_tax,\n    o.total_discounts\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n)\nSELECT \n  'CLV Profit' as metric,\n  customer_type,\n  ROUND((SUM(total_price) - SUM(total_tax) - SUM(total_discounts)) / NULLIF(COUNT(DISTINCT customer_id), 0), 2) as profit_value\nFROM customer_order_seq\nGROUP BY customer_type\nORDER BY customer_type DESC\nLIMIT 10\n",
            "formula": "Net Profit per Customer compared between New Customers (first purchase) and Returning Customers (repeat purchases)",
            "data": [
                {
                    "metric": "CLV Profit",
                    "profit_value": 1157.37,
                    "customer_type": "Returning Customer"
                },
                {
                    "metric": "CLV Profit",
                    "profit_value": 185.24,
                    "customer_type": "New Customer"
                }
            ],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Customer Type",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "CLV Profit (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CLV Profit",
                            "type": "bar",
                            "encode": {
                                "x": "customer_type",
                                "y": "profit_value"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Identify each customer's first order as new customer and subsequent orders as returning customer. Calculate net profit (total price minus tax and discounts) per customer for each group, then compare CLV profit between new and returning customers.",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 20,
                "w": 6,
                "h": 8
            }
        }
    ]
}

export const INIT_SCHEMA = {
    "kpi": [
        {
            "id": "cf93de0d-bd07-47f1-a9e8-d8ff23d5e875",
            "sql": "SELECT SUM(total_price) as total_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_sales": 8796.6}
            ],
            "unit": "USD",
            "title": "Total Sales",
            "action": "update",
            "column": "total_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Total Sales = Sum of all order totals (subtotal + tax + shipping - discounts)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the total amount of all orders including tax and shipping fees.",
            "prevData": [
                {"total_sales": null}
            ]
        },
        {
            "id": "6005cded-3971-46da-ae5f-216252d391cb",
            "sql": "SELECT SUM(subtotal_price) as net_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"net_sales": 8796.6}
            ],
            "unit": "USD",
            "title": "Net Sales",
            "action": "update",
            "column": "net_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Net Sales = Sum of subtotal price (merchandise before tax and shipping)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the subtotal amount of all orders excluding tax and shipping fees.",
            "prevData": [
                {"net_sales": null}
            ]
        },
        {
            "id": "55271edf-d226-47fc-abd1-cf2a1556f727",
            "sql": "SELECT SUM(price * quantity) as gross_sales FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'",
            "data": [
                {"gross_sales": 4880}
            ],
            "unit": "USD",
            "title": "Gross Sales",
            "action": "update",
            "column": "gross_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Gross Sales = Sum of (price × quantity) for all line items",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter all line items within the specified date range from the order items table, and sum the product of unit price and quantity for each line item.",
            "prevData": [
                {"gross_sales": null}
            ]
        },
        {
            "id": "10724363-a442-45ac-9957-8417d8780cd2",
            "sql": "SELECT COUNT(DISTINCT order_id) as total_orders FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_orders": 32}
            ],
            "unit": "Orders",
            "title": "Orders",
            "action": "update",
            "column": "total_orders",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 0
            },
            "formula": "Orders = Count of distinct orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and count the distinct number of orders.",
            "prevData": [
                {"total_orders": 0}
            ]
        },
        {
            "id": "2087cc56-ead4-464b-b488-c19e81944809",
            "sql": "SELECT AVG(subtotal_price) as aov_net FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"aov_net": 274.89375}
            ],
            "unit": "USD",
            "title": "AOV (Net)",
            "action": "update",
            "column": "aov_net",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 2
            },
            "formula": "AOV (Net) = Sum of subtotal price / Count of orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the average order subtotal (total subtotal divided by number of orders).",
            "prevData": [
                {"aov_net": null}
            ]
        },
        {
            "id": "0b7bbf07-9188-4437-bd6d-67fb05ea51ac",
            "sql": "SELECT SUM(quantity) as products_sold FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'",
            "data": [
                {"products_sold": 12}
            ],
            "unit": "Units",
            "title": "Products Sold",
            "action": "update",
            "column": "products_sold",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 2
            },
            "formula": "Products Sold = Sum of quantity across all line items",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter all line items within the specified date range from the order items table, and sum the quantity of all line items.",
            "prevData": [
                {"products_sold": null}
            ]
        },
        {
            "id": "4abe79b6-55b1-4857-9ef1-2a2208098223",
            "sql": "SELECT SUM(total_discounts) as total_discounts FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_discounts": 0}
            ],
            "unit": "USD",
            "title": "Discounts",
            "action": "update",
            "column": "total_discounts",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 2
            },
            "formula": "Discounts = Sum of all discount amounts from orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and sum the total discount amount of all orders.",
            "prevData": [
                {"total_discounts": null}
            ]
        },
        {
            "id": "f6013d51-0f46-4027-8c24-36e7894e3c1e",
            "sql": "SELECT COALESCE(SUM(total_price), 0) as total_refunds FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NOT NULL",
            "data": [
                {"total_refunds": 0}
            ],
            "unit": "USD",
            "title": "Refunds",
            "action": "update",
            "column": "total_refunds",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 2
            },
            "formula": "Refunds = Sum of total price for cancelled orders (returns 0 if no cancelled orders exist)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter cancelled orders within the specified date range from the orders table, and sum the total amount of cancelled orders as refund amount, returning 0 if no cancelled orders exist.",
            "prevData": [
                {"total_refunds": 0}
            ]
        },
        {
            "id": "f1c715df-6f48-49a9-825e-b04cfe510e55",
            "sql": "SELECT SUM(total_price - subtotal_price - total_tax) as shipping_revenue FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00' AND cancelled_at IS NULL",
            "data": [
                {"shipping_revenue": 0}
            ],
            "unit": "USD",
            "title": "Shipping Revenue",
            "action": "update",
            "column": "shipping_revenue",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 4
            },
            "formula": "Shipping Revenue = Sum of (total price - subtotal price - tax) for all orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, calculate shipping revenue (total price minus subtotal and tax for each order), and sum the result.",
            "prevData": [
                {"shipping_revenue": null}
            ]
        },
        {
            "id": "e8352533-0216-4b57-b1a4-2132e2cd90c3",
            "sql": "SELECT COUNT(DISTINCT customer_id) as new_customers FROM semantic.dm_customers_shopify WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'",
            "data": [
                {"new_customers": 13}
            ],
            "unit": "Customers",
            "title": "New Customers",
            "action": "update",
            "column": "new_customers",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 4
            },
            "formula": "New Customers = Count of distinct customers whose registration date falls within the period",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter customers with registration date within the specified date range from the customers table, and count the distinct number of customers.",
            "prevData": [
                {"new_customers": 0}
            ]
        },
        {
            "id": "cd4a20ba-d50e-4b14-8489-9104dd906dea",
            "sql": "SELECT COUNT(DISTINCT o.order_id) as returning_orders FROM semantic.dm_orders_shopify o JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-10T14:44:48+08:00' AND o.created_at <= '2026-01-08T14:44:48+08:00' AND o.cancelled_at IS NULL AND c.orders_count > 1",
            "data": [
                {"returning_orders": 28}
            ],
            "unit": "Orders",
            "title": "Returning Orders",
            "action": "update",
            "column": "returning_orders",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 4
            },
            "formula": "Returning Orders = Count of orders from customers with orders_count > 1",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join orders table with customers table, filter paid orders within the specified date range that are not cancelled and from customers with historical order count greater than 1, and count the distinct number of orders.",
            "prevData": [
                {"returning_orders": 0}
            ]
        }
    ],
    "chart": [
        {
            "id": "dd3d1c1f-d7ce-4d69-91e4-4db68d62b6bf",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(total_price) as total_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "total_sales": 2795.4
                },
                {
                    "date": "2026-01-08",
                    "total_sales": 3660
                }
            ],
            "title": "Total Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 6
            },
            "formula": "Total Sales by Date = Sum of order total price (including tax and shipping) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date, sum the total order amount (including tax and shipping), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Total Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Total Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "total_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "1558f2eb-0561-48cf-a7a1-21b890a7cb77",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  COUNT(DISTINCT order_id) as orders\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "orders": 11
                },
                {
                    "date": "2026-01-08",
                    "orders": 9
                }
            ],
            "title": "Orders",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 6
            },
            "formula": "Orders by Date = Count of distinct paid orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date, count distinct orders, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Orders",
                            "type": "bar",
                            "encode": {
                                "x": "date",
                                "y": "orders"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "bc8dc736-a20c-4ac6-b11f-f7ddc46e53b6",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(total_price) as net_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\n  AND cancelled_at IS NULL\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "net_sales": 2795.4
                },
                {
                    "date": "2026-01-08",
                    "net_sales": 3660
                }
            ],
            "title": "Net Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 14
            },
            "formula": "Net Sales by Date = Sum of total price for non-cancelled paid orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid, non-cancelled orders within the specified date range from the orders table, group by date, sum the total order amount, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Net Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Net Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "net_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "d5a4e2b9-11e2-4216-b53d-0c0d7d0ce67f",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(subtotal_price) as gross_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "gross_sales": 2795.4
                },
                {
                    "date": "2026-01-08",
                    "gross_sales": 3660
                }
            ],
            "title": "Gross Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 14
            },
            "formula": "Gross Sales by Date = Sum of subtotal price (before tax/shipping/discounts) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date, sum the subtotal amount (before tax, shipping, and discounts), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Gross Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Gross Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "gross_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "d64a8bed-7eda-46c5-87ab-2b5c6e41f578",
            "sql": "SELECT \n  DATE_TRUNC('week', created_at AT TIME ZONE 'Asia/Shanghai')::date as week,\n  SUM(total_price) / NULLIF(COUNT(DISTINCT order_id), 0) as aov_net\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\n  AND cancelled_at IS NULL\nGROUP BY DATE_TRUNC('week', created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY week",
            "data": [
                {
                    "week": "2026-01-05",
                    "aov_net": 322.77
                }
            ],
            "title": "AOV (Net)",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 22
            },
            "formula": "AOV (Net) by Week = Total Net Sales / Number of Orders grouped by week",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid, non-cancelled orders within the specified date range from the orders table, group by week, calculate average order value (total sales divided by order count), and sort by week in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "AOV USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "AOV (Net)",
                            "type": "line",
                            "encode": {
                                "x": "week",
                                "y": "aov_net"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "9d13ff84-b328-4272-972c-07aa4e48aa5f",
            "sql": "SELECT \n  DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(oi.quantity) as products_sold\nFROM semantic.dm_order_items_shopify oi\nJOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id\nWHERE o.created_at >= '2025-12-10T14:44:48+08:00' AND o.created_at <= '2026-01-08T14:44:48+08:00'\n  AND o.financial_status = 'paid'\nGROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "products_sold": 3
                },
                {
                    "date": "2026-01-08",
                    "products_sold": 9
                }
            ],
            "title": "Products Sold",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 22
            },
            "formula": "Products Sold by Date = Sum of quantity from all line items grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join order items table with orders table, filter paid orders within the specified date range, group by date, sum the quantity of all line items, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Units Sold",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Products Sold",
                            "type": "bar",
                            "encode": {
                                "x": "date",
                                "y": "products_sold"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "5ffdd2d5-2b5f-4629-b0b1-b32ab6aa1ae0",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(total_discounts) as discounts,\n  ABS(SUM(CASE WHEN cancelled_at IS NOT NULL THEN total_price ELSE 0 END)) as refunds\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "refunds": 0,
                    "discounts": 0
                },
                {
                    "date": "2026-01-08",
                    "refunds": 0,
                    "discounts": 0
                }
            ],
            "title": "Discounts + Refunds",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 30
            },
            "formula": "Discounts + Refunds by Date = Sum of discounts and refunded amounts grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter all orders within the specified date range from the orders table, group by date, sum the total discount amount and cancelled order amount (as refunds), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Amount USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Discounts",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "discounts"
                            }
                        },
                        {
                            "name": "Refunds",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "refunds"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "28dc81a0-9c87-4623-a544-caac03ce8d47",
            "sql": "SELECT \n  DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(CASE WHEN c.orders_count = 1 THEN o.total_price ELSE 0 END) as new_sales,\n  SUM(CASE WHEN c.orders_count > 1 THEN o.total_price ELSE 0 END) as returning_sales\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:44:48+08:00' AND o.created_at <= '2026-01-08T14:44:48+08:00'\n  AND o.financial_status = 'paid'\nGROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "new_sales": 519.85,
                    "returning_sales": 2275.55
                },
                {
                    "date": "2026-01-08",
                    "new_sales": 0,
                    "returning_sales": 3660
                }
            ],
            "title": "New Sales vs Returning Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 38
            },
            "formula": "New Sales vs Returning Sales by Date = Sales grouped by customer type (first-time vs repeat)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join orders table with customers table, filter paid orders within the specified date range, group by date, classify sales by customer type (first-time vs repeat based on historical order count), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Customer Sales",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "new_sales"
                            }
                        },
                        {
                            "name": "Returning Customer Sales",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "returning_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "2ed13f4e-9ca4-4451-8518-2a352649025c",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(total_price - subtotal_price - total_tax) as shipping_revenue\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "shipping_revenue": 0
                },
                {
                    "date": "2026-01-08",
                    "shipping_revenue": 0
                }
            ],
            "title": "Shipping Revenue",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 38
            },
            "formula": "Shipping Revenue by Date = (Total Price - Subtotal - Tax) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date, calculate shipping revenue (total price minus subtotal and tax), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Shipping USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Shipping Revenue",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "shipping_revenue"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "45d1d6b5-0dd4-44bb-abc0-cc1545dbb1ac",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(subtotal_price) as demand_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "demand_sales": 2795.4
                },
                {
                    "date": "2026-01-08",
                    "demand_sales": 3660
                }
            ],
            "title": "Demand Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 46
            },
            "formula": "Demand Sales by Date = Sum of subtotal price (before discounts/tax/shipping) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date, sum the subtotal amount (before discounts, tax, and shipping), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Demand Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Demand Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "demand_sales"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "be6a0cc9-fb60-4386-8fb2-0cbe4a2212b8",
            "sql": "SELECT \n  DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  COUNT(CASE WHEN c.orders_count = 1 THEN o.order_id ELSE NULL END) as new_orders,\n  COUNT(CASE WHEN c.orders_count > 1 THEN o.order_id ELSE NULL END) as returning_orders\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:44:48+08:00' AND o.created_at <= '2026-01-08T14:44:48+08:00'\n  AND o.financial_status = 'paid'\nGROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "new_orders": 3,
                    "returning_orders": 8
                },
                {
                    "date": "2026-01-08",
                    "new_orders": 0,
                    "returning_orders": 9
                }
            ],
            "title": "Orders Mix",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 30
            },
            "formula": "Orders Mix by Date = Count of orders grouped by customer type (first-time vs repeat)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join orders table with customers table, filter paid orders within the specified date range, group by date, classify orders by customer type (first-time vs repeat based on historical order count), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Orders",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "new_orders"
                            }
                        },
                        {
                            "name": "Returning Orders",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "returning_orders"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "b48b0f58-241a-4abc-aa22-e2908891b919",
            "sql": "SELECT \n  DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week,\n  SUM(oi.quantity)::numeric / NULLIF(COUNT(DISTINCT o.order_id), 0) as qty_per_order\nFROM semantic.dm_order_items_shopify oi\nJOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id\nWHERE o.created_at >= '2025-12-10T14:44:48+08:00' AND o.created_at <= '2026-01-08T14:44:48+08:00'\n  AND o.financial_status = 'paid'\nGROUP BY DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY week",
            "data": [
                {
                    "week": "2026-01-05",
                    "qty_per_order": 0.6
                }
            ],
            "title": "Quantity per Order",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 46
            },
            "formula": "Quantity per Order by Week = Total Units Sold / Number of Orders grouped by week",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join order items table with orders table, filter paid orders within the specified date range, group by week, calculate average quantity per order (total units divided by order count), and sort by week in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Units per Order",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Quantity per Order",
                            "type": "line",
                            "encode": {
                                "x": "week",
                                "y": "qty_per_order"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "63857dea-e2da-428f-b738-2b3d63a8b8fd",
            "sql": "WITH monthly_revenue AS (\n  SELECT \n    DATE_TRUNC('month', created_at AT TIME ZONE 'Asia/Shanghai')::date as month,\n    SUM(total_price) as revenue\n  FROM semantic.dm_orders_shopify\n  WHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n    AND financial_status = 'paid'\n  GROUP BY DATE_TRUNC('month', created_at AT TIME ZONE 'Asia/Shanghai')\n)\nSELECT \n  month,\n  CASE \n    WHEN LAG(revenue) OVER (ORDER BY month) = 0 OR LAG(revenue) OVER (ORDER BY month) IS NULL THEN 0\n    ELSE (revenue - LAG(revenue) OVER (ORDER BY month)) * 100.0 / LAG(revenue) OVER (ORDER BY month)\n  END as growth_rate\nFROM monthly_revenue\nWHERE month >= '2025-12-01'::date\nORDER BY month",
            "data": [
                {
                    "month": "2026-01-01",
                    "growth_rate": 0
                }
            ],
            "title": "Revenue Growth Rate",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 54
            },
            "formula": "Revenue Growth Rate by Month = (Current Month Revenue - Previous Month Revenue) / Previous Month Revenue × 100",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by month to calculate monthly revenue, then calculate month-over-month growth rate (current month revenue minus previous month revenue divided by previous month revenue times 100), returning 0 if previous month is null or zero, and sort by month in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Month",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Growth Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Revenue Growth Rate",
                            "type": "line",
                            "encode": {
                                "x": "month",
                                "y": "growth_rate"
                            }
                        }
                    ]
                }
            }
        },
        {
            "id": "f7d4fcd2-d6a1-48b7-8cc7-29a59194fc13",
            "sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(SUM(total_price)) OVER (ORDER BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')) as cumulative_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:48+08:00' AND created_at <= '2026-01-08T14:44:48+08:00'\n  AND financial_status = 'paid'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "data": [
                {
                    "date": "2026-01-07",
                    "cumulative_sales": 2795.4
                },
                {
                    "date": "2026-01-08",
                    "cumulative_sales": 6455.4
                }
            ],
            "title": "Pacing Sales",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 54
            },
            "formula": "Pacing Sales = Cumulative sum of daily sales to track progress toward period target",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter paid orders within the specified date range from the orders table, group by date to calculate daily sales, then calculate cumulative sales using window function, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Cumulative Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Pacing Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "cumulative_sales"
                            }
                        }
                    ]
                }
            }
        }
    ]
}